// assets
import {
  UserOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  SendOutlined
} from '@ant-design/icons';

// icons
const icons = {
  UserOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  SendOutlined
};

// ==============================|| MENU ITEMS - BASE DE DATOS ||============================== //

const pages = {
  id: 'base-datos',
  title: 'Base de Datos',
  type: 'group',
  children: [
    {
      id: 'usuarios',
      title: 'Usuarios',
      type: 'item',
      url: '/usuarios',
      icon: icons.UserOutlined
    },
    {
      id: 'distritos',
      title: 'Distritos',
      type: 'item',
      url: '/distritos',
      icon: icons.EnvironmentOutlined
    },
    {
      id: 'socios',
      title: 'Socios',
      type: 'item',
      url: '/socios',
      icon: icons.TeamOutlined
    },
    {
      id: 'envios',
      title: 'Envíos',
      type: 'item',
      url: '/envios',
      icon: icons.SendOutlined
    },
    {
      id: 'envios2',
      title: 'Envíos2',
      type: 'item',
      url: '/enviosa',
      icon: icons.SendOutlined
    }
  ]
};

export default pages;
